<template>
  <CatalogComponent
    :application="application"
    :cart="cart_items"
    :load_app.sync="load_app"
    :loading="loading"
    :next-step="nextStep"
    :search_text="$t('Catalog.Search')"
    :title="$t('Catalog.MakePurchase')"
    @previousStep="previousStep">
    <template #step_number>
      <StepNumber
        all_steps="3"
        step="1"/>
    </template>
    <template #search_bar>
      <EditCartResource
        :app="application"
        :cart.sync="cart"
        @searching="searching"/>
    </template>
    <template #treeview>
      <v-list
        v-if="search && searched.length"
        class="main__light_green">
        <v-list-item-group
          v-model="selected_id"
          multiple>
          <template v-for="item in searched">
            <v-list-item
              :key="item.id"
              :disabled="!!loading"
              :value="item.id"
              @click="selectElastic(item)">
              <template #default="{ active }">
                <v-list-item-action class="ma-0 mr-2">
                  <v-checkbox
                    color="var(--black-color)"
                    hide-details
                    :input-value="active"/>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title v-dompurify-html="item.Value || item.name || item.resourceName"/>
                  <v-list-item-subtitle
                    v-dompurify-html="item.resourceGroupName"
                    class="text-start"/>
                </v-list-item-content>
              </template>
            </v-list-item>
            <sDivider
              :key="item.id + 'idivider'"/>
          </template>
        </v-list-item-group>
      </v-list>

      <div
        v-else-if="search && !searched.length"
        class="h5-headline mt-10 text-start col-6 pa-0 black--text">
        {{ $t('Tenders.NoPositions') }}  “{{ search }}”. {{ $t('Tenders.YouCanAddNew') }}
      </div>
      <ResourceTree
        v-else
        ref="catalog"
        :append_text="item => item.children && item.children.length > 0 ? item.children.length : getMeasur(item)"
        :append_text_title="item => item.children && item.children.length > 0 ? '' : getMeasur(item, true)"
        :item-disabled="loading ? 'locked' : 'is_locked'"
        :items="groups"
        :load-children="fetchChildItems"
        :loading="item => loading == item.id"
        open-on-click
        :outline_folder="item => item.children.length > 0"
        :outlined_file="item => item.children"
        :select-disable="!!loading"
        :selected_positions.sync="selected_positions"/>
    </template>
    <template #clear_cart>
      <sButton
        :disabled="!!loading"
        icon="delete"
        small
        type="text"
        @click.stop="deleteAllCart">
        {{ $t('Common.Clear') }}
      </sButton>
    </template>
    <template #cart_list>
      <CartList
        :get-group="getGroup"
        :get-measur="getMeasur"
        :get-name="getName"
        :key-field="application ? 'rowId' : 'id'"
        :list.sync="cart_items"
        :loading="loading == 'select'"
        @delete="cancelSelection">
        <template #edit="{ item }">
          <EditCartResource
            :app.sync="application"
            :cart.sync="cart_items"
            :deselect="deselect"
            :item="item"/>
        </template>
      </CartList>
    </template>
    <template #footer>
      <ComponentFooter
        key="footer"
        :back="previousStep"
        back_btn
        :loading="!!loading"
        :next="nextStep"
        next_btn/>
    </template>
  </CatalogComponent>
</template>

<script>
import CartList from 'components/common/blocks/CartList.vue'
import StepNumber from 'components/common/elements/StepNumber.vue'
import CatalogComponent from 'pages/templates/CatalogComponent.vue'
import ResourceTree from 'components/common/blocks/ResourceTree.vue'
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import EditCartResource from 'components/purchasing/new purchase/EditCartResource.vue'

// import { ApplicationRowDraft } from '@/types/application_draft.js'
import ApplicationsApi from '@/api/applicationApi'
import CartApi from '@/api/cartItemsApi'
import CatalogueApi from '@/api/catalogueApi'
import elasticApi from '@/api/elasticApi'
import { applicationMixin, } from 'mixins'

const elastic_api = new elasticApi()
const cart_api = new CartApi()
const api = new ApplicationsApi()
const catalog_api = new CatalogueApi()

export default {
  name: 'formPurchase',
  mixins: [applicationMixin],
  data() {
    return {
      timeout: 0,
      count: 0,
      opened: [],
      groups: [],
      search: null,
      searched: [],
      cart: [],
      selected_positions: [],
      page: 1,
      loading: false,
      selected_id: [],
      newCartClassificationCode: '',
      resources: [],
      load_app: false,
      application: null,
    }
  },
  props: {
    app: [ Number, String],
    changeStep: Function
  },
  async created() {
    this.loading = true
    this.loadMoreGroups()
    if (this.app) {
      this.load_app = true
      this.application = await this.getApp(this.app)
      if ( this.application.state != 'П' ) {
        this.$router.push( {name: 'purchitem', params: {id: this.application.id , org: this.$route.params.org}})
      }
      this.cart = this.application?.rows?.map(el => el?.resource || el )
      this.load_app = false
    } else {
      await cart_api.getCartItems()
        .then( res => {
          if (res.data.cartItems?.length) {
            res.data.cartItems.forEach(item => {
              if (item.resource) {
                return item.resource
              } else if (item.resourceName) {
                item.resource = {
                  fullName: item?.resourceName,
                  id: item?.id
                }
              }
            })
            this.cart = res.data.cartItems.map(el => el?.resource)
          }
        })
    }
    window.addEventListener('scroll', this.listnerSetup)
  },
  unmounted() {
    window.removeEventListener('scroll', this.listnerSetup)
  },
  computed: {
    cart_items: {
      get() {
        if (this.application) {
          return this.application.rows.map(item => ( item?.resource ? { ...item?.resource,
            resourceName: item?.resourceName || item?.fullName,
            unit: item?.unit,
            description: item?.description,
            rowId: item?.id
          } : item ))
        } else {
          return this.$store.getters['getCartItems']
        }
      },
      set(val) {
        if (this.application) {
          return this.application.rows = val
        } else {
          this.$store.commit('setCartItems', val)
        }
      }
    },
  },
  methods: {
    listnerSetup() {
      const windowRelativeBottom = document.documentElement.getBoundingClientRect().bottom,
        visible = document.documentElement.clientHeight,
        bottomOfPage = windowRelativeBottom < visible + 150
      if (bottomOfPage && !this.loading && this.count && this.loading != 11) {
        this.loadMoreGroups()
      }
    },
    async loadMoreGroups() {
      const visible = document.documentElement.clientHeight,
        per_page = Math.round((visible / 40) * 4 )
      this.loading = this.count ? this.count / per_page : true

      catalog_api.getResourcesGroups(null, per_page, this.count )
        .then(this.hierarchyCallback)
        .then(res => {
          if (res?.data?.resourcesGroups.length) {
            this.count += per_page
          } else {
            this.count = false
          }
        })
        .finally( () => this.loading = false)
    },
    async select(value, condition) {
      let  diff = async (a, b) => {
          if (a.length > b.length) {
            await findDiff(a, b, true)
          } else if (b.length > a.length) {
            await findDiff(b, a)
          }
        },
        findDiff = async (a, b, add) => {
          let promises =  a.filter( el =>  !!this.resources.find(it => (it?.resource?.id  || it.id) == (el?.resource?.id  || el?.id))
              && !b.find( it => (it?.resource?.id  || it?.id) == (el?.resource?.id  || el?.id)))

          return await this.mutateCart(promises, add)
        }
      value = value?.filter(el => el?.__typename != 'ResourceGroupGraph' && !el?.resource)
      this.selected_positions = value.slice(0)
      /*if (!this.selected_id?.length) {
        this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: 'ERROR_SELECT_ID'
        })

        this.$log_error('selected_id', this.selected_id)
      }*/
      this.selected_id.forEach(el => {

        if (!this.$refs?.catalog?.$refs.catalog?.nodes[el]
          && !value?.find(it => it?.id == el)) {
          value.push(this.resources.find(it => it?.id == el))
        }
      })
      /*if (!this.cart_items.length) {
        this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: 'ERROR_CART_ITEMS'
        })

        this.$log_error('cart_items', this.cart_items)
      }*/
      this.cart_items.forEach(el => {
        if ( !this.resources.some(it => it.id == (el?.resource?.id  || el?.id) )
          && !value.find(it => it?.id == (el?.resource?.id  || el?.id)) ) {
          value.push(el?.resource || el)
        }
      })
      let cart_items = this.cart_items
      if ( this.application ) {
        let groups = this.$_.groupBy(this.cart_items, 'id' ),
          vals = Object.values(groups)
        if (vals.some(el => el.length > 1)) {
          cart_items = []
          /*if (!vals?.length) {
            this.$notice.warning({
              title: this.$t('Common.ErrorTitle'),
              message: 'ERROR_VALS'
            })
            this.$log_error('cart_items', this.cart_items)
            this.$log_error('groups', groups)
          }*/
          vals.forEach(group => {
            if ( value.some(res => res.id == group[0].id) ) { // якщо є в обраних то додавати тільки один з однакових, якщо немає одавати всі що всіх їх і видалити
              cart_items.push(group[0])
            } else {
              cart_items.push(...group)
            }

          })
        }
      }
      if (value.length == cart_items.length || condition ) { return }
      this.loading = 'select'

      await diff(value, cart_items)
      this.cart = value

      this.loading = false
    },
    async mutateCart(items, add) {
      // let app
      let cart_items = Array.isArray(items) ? this.$_.map( items, it => {
        if ( it.resource && it.id || add ) {  return it.id }
        return  this.cart_items.find(el => (el?.resource && el?.resource?.id == it?.id) || (el?.id == it?.id) )?.id
      } ) : []
      if (add) {
        if (this.application) {
          return await api.addRowsToDraft({
            rows: items.map(item => ({
              resourceId: item.resourceId || item.resource?.id || item.id
            })),
            headerId: this.application.id
          })
            .then (res =>  {
              if (!res?.length ) { return }
              this.application.rows.push( ...res )
            })
        } else {
          return await cart_api.addToCartMutation( cart_items )
        }
      } else  {
        if (this.application) {
          return await api.deleteRows(this.application.id, this.$_.map( items, 'rowId') ).then( res  => {
            if (!res?.data?.deleteRows) { return  }
            this.application.rows =  this.application.rows.filter(el => !items.some(it =>  el?.id == it?.rowId))
          })
        } else {

          if (cart_items) {
            return await cart_api.deleteCartItemsMutation( cart_items )
          }
        }
      }
    },
    async selectElastic(value) {
      if (!value) { return }
      let cart = [...this.cart]
      let resource =  this.resources.find(el => value?.id == el ? el?.id : '')
      if (!resource) {
        resource = value
        this.resources.push( value)
      }
      if (this.selected_positions.find(x => x?.id == value?.id)) {
        this.selected_id = this.selected_id.filter(x => x != value?.id)
        this.selected_positions = this.selected_positions.filter(el => el?.id != value?.id)
        this.cart = cart
        this.select(this.selected_positions)
      } else {
        this.selected_positions.push(resource)
        this.cart = cart
        this.select(this.selected_positions)
      }

    },
    async cancelSelection(itemObject) {
      const item = itemObject.item
      this.loading = 'select'
      await this.mutateCart([item])
      this.selected_positions = this.application ? this.cart_items : this.cart_items.map(el => el?.resource)
      this.selected_id = this.selected_id.filter(x => x != item?.item?.resource?.id)
      this.cart = this.selected_positions
      this.loading = false
    },
    deselect(item) {
      this.selected_positions =  this.selected_positions.filter(el => el?.id !=  item?.resource?.id )
      this.selected_id = this.selected_id.filter(x => x != item?.resource?.id)
    },
    async nextStep() {
      if (!this.cart_items.length) {
        this.$notice.info({
          title: this.$t('Catalog.NoRowsTitle'),
          message: this.$t('Catalog.NoRowsText'),
          showClose: true,
          progress: true,
          duration: 20
        })
        return
      }
      // this.$root.$emit('showOverlay')
      // this.loading = true

      if (!this.application) {
        await api.createApplication()
          .then( async res => {
            await this.changeStep(true, res?.data?.createApplication)
          })
      } else {
        await this.changeStep( true, this.application)
      }
      // this.$root.$emit('closeOverlay')
      // this.loading = false
    },
    async previousStep() {
      await this.changeStep( false)
    },
    updateTree(item, childrens) {
      let key = item?.id
      let parentNode = this.$refs.catalog.$refs.catalog.nodes[key]

      for (let itemKey in childrens) {
        if (childrens.hasOwnProperty(itemKey)) {
          let child = childrens[itemKey]
          let childNode = {...parentNode, item: child, parent: key, vnode: null}
          this.$refs.catalog.$refs.catalog.nodes[child?.id] = childNode
        }
      }
    },
    async fetchChildItems(item) {
      if (item.children.length > 0) {
        return item.children
      }
      this.loading = item?.id
      return new Promise(async (resolve, reject) => {
        let ret = []
        let resources =  await catalog_api.getResources(item?.id, false)
          .catch(err => reject(err))

        if (resources.length > 0) {
          ret.push(
            ...resources.map( i => {
              return { ...i, parentId: item?.id }
            }).filter(el => !item.children.find(it => it?.id == el?.id))
          )
          this.resources.push( ...ret)
        }
        let groups = ( await catalog_api.getResourcesGroups(item?.id).catch(err => reject(err)))
        if (groups.length > 0) {
          ret.push(
            ...(groups[0].children.map( i => {
              i.children = []
              i.parentId = item?.id
              return i
            }))
          )
        }
        if (ret.length > 0) {
          this.updateTree(item, ret)
        }
        resolve(ret)

      })
        .then(res => {
          item.children.push(...res)
          setTimeout(() => {
            this.selected_positions = this.application ? this.cart_items
              : this.cart_items.map(el => el?.resource || el.id)
          }, 500)

          this.$refs.catalog.$refs.catalog.buildTree(this.groups)
          return res
        })
        .catch(err => this.$log_error(err))
        .finally(() => this.loading = null )
    },
    hierarchyCallback(resp) {
      if (!resp) { return }
      /*if (!resp?.length) {
        this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: 'ERROR_RESP'
        })
        this.$log_error('resp', resp)
      }*/
      resp.forEach(elem => {
        elem.children =
          elem?.children?.map(item => {
            item.children = []
            return item
          })
        elem.locked = true
      })
      this.groups.push(...resp)
      return resp
    },
    searching(val) {
      this.search = val
      if (val != null && val.length > 0) {
        this.loading = true
        elastic_api.resourcesElastic(this.search)
          .then(this.selectedCallback)
          .finally(this.calcelSearching)
      } else {
        this.searched = []
      }
    },
    selectedCallback(res) {
      if (!res) {
        return
      }
      this.searched = res
      let cart = [...this.cart || []]
      this.selected_positions = cart
      this.selected_id = cart?.map(el => el?.id) || []
    },
    calcelSearching() {
      clearTimeout(this.timeout)
      this.loading = false
    },

    getMeasur(item, long) {
      let full_name = item.unit?.fullName,
        short = item.unit?.name
      return (long ? full_name || short : short || full_name) || ''
    },
    getGroup(item) {
      if ( item.category ) {
        return item.category.code + ' ' + item.category.name
      } else if (item.resource && item.resource.category) {
        return item.resource.category.code + ' ' + item.resource.category.name
      }
    },
    getName(item) {
      return item.resource?.name || item.resourceName || item.name
    },
    async deleteAllCart() {
      this.loading = 'select'
      if (this.app) {
        await api.deleteRows( this.application?.id || this.app,  this.application.rows.map(el => el.id))
          .then(() => {
            this.cart = []
            this.selected_positions = []
            this.selected_id = []
            this.application.rows = []
          })
          .catch(error => this.$log_error(error.message))
      } else {
        await cart_api.deleteCartItemsMutation(this.$_.map(this.cart_items, 'id') ).then(() => {
          this.cart = []
          this.selected_positions = []
          this.selected_id = []
        })
      }

      this.loading = false
    }
  },
  watch: {
    selected_positions(new_selected, old) {
      if (this.loading ) {
        new_selected = old
      } else
        if (new_selected.length != old.length ) {
          this.select(new_selected.slice(0))
        }
    }
  },
  components: {
    CartList,
    StepNumber,
    ResourceTree,
    ComponentFooter,
    CatalogComponent,
    EditCartResource,
  }
}
</script>
<style lang="scss">
  .highlight-elastic {
    font-weight: 600;
  }
</style>
